export const SEARCH_TERM_MAP = {
  Red: 'Red',
  Blue: 'Blue',
  Orange: 'Accessible',
  Visitor: 'Meter',
};

export const CARPARK_BREAKPOINTS = [
  {
    mq: '(max-width: 579px)',
    value: 'S',
  },
  {
    mq: '(min-width: 580px)',
    value: 'L',
  },
];
